import React, { FC, PropsWithChildren } from 'react';

import styles from './ScreenReadersOnly.module.css';

/**
 * Don't forget to set "position" style-property of parent container.
 */
export const ScreenReadersOnly: FC<PropsWithChildren<{}>> = ({ children }) => (
    <div className={styles.srRoot}>{children}</div>
);
